import type { ClassData, ConstructorData } from '@/core/types/library.type'
import { formatCodeSnippetParams } from '@/core/utils/builder/formatCodeSnippetParams.builder'
import { getInstanceVariableName } from '@/core/utils/getInstanceVariableName'

type BuildConstructorSnippetParams = {
  classData: ClassData
  constructor: ConstructorData
  instanceCode: string
  technology?: string
}

export const buildConstructorSnippet = ({
  classData,
  constructor,
  instanceCode,
  technology,
}: BuildConstructorSnippetParams): string => {
  if (!instanceCode) return ''

  const params = formatCodeSnippetParams(constructor.parameters.map((parameter) => parameter.name))

  return instanceCode
    .replaceAll('{class}', classData.name)
    .replaceAll('{name}', getInstanceVariableName(classData.name, technology))
    .replaceAll('{params}', params)
}
